import { PropsWithChildren } from "react";
import { I18nextProvider } from "react-i18next";
import i18next from "@/data/config/i18n.ts";
import "@/data/config/i18n";

export default function I18nProvider({ children }: PropsWithChildren) {
  return <I18nextProvider i18n={i18next}>{children}</I18nextProvider>;
}
